module.exports = __webpack_public_path__ + "static/media/system.d9b34ca9.png";